<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!items.length"
    >
    <vbt-table
      :headers="headers"
      :items="items"
      show-paginator
    >
      <template #actions="{ item }">
        <v-layout justify-end>
          <v-btn
            v-for="(action, i) in actions[item.event]"
            :key="`action-${i}`"
            :color="actionColor[action]"
            class="mr-2"
            small
            text
            @click="doAction(action, item)"
          >
            {{ action }}
          </v-btn>
        </v-layout>
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
import { mapState } from 'vuex';

import { wrapToLoadingFn } from '@helpers';

import { namespace as LocationsNamespaces } from '@store/modules/locations.types';

import PressSheetsApiService from '../_services/pressSheets.api.service';

const headers = Object.freeze([
  { text: 'Action', value: 'action' },
  { text: 'Event', value: 'event' },
  { text: 'Side', value: 'side' },
  { text: '', value: 'actions', width: '250px' },
]);

export default {
  name: 'KernelPressSheetActionsList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  computed: {
    ...mapState(LocationsNamespaces, ['suffix']),
    actions: () => ({
      1: ['revert'],
      2: ['resume'],
      3: ['start'],
      4: ['pause', 'abort', 'stop'],
    }),
    actionColor: () => ({
      revert: 'warning',
      pause: 'warning',
      resume: 'info',
      start: 'info',
      abort: 'error',
      stop: 'error',
    }),
    nextEventState: () => ({
      abort: 5,
      start: 6,
      stop: 7,
      pause: 8,
      resume: 9,
    }),
  },
  methods: {
    doAction(type, payload) {
      const {
        [type === 'revert' ? 'revertPressSheet' : 'progressPressSheet']: action,
      } = PressSheetsApiService;

      this.$VBlackerTheme.alert.warning({
        withInput: type === 'revert' || type === 'abort',
        text: `Did you want ${type} press sheet?`,
      }, ({ value }) => this.wrapToLoadingFn({
        req: action.bind({}, {
          suffix: this.suffix,
          id: this.$route.params.id,
          action: payload.action,
          event: type !== 'revert' ? this.nextEventState[type] : null,
          description: value || null,
        }),
        onSuccess: () => this.$emit('refresh'),
      }));
    },
    wrapToLoadingFn,
  },
};
</script>
